<template>
  <div>
    <Header />

    <v-container
      class="mt-10"
    >
      <v-card
        :loading="isLoading"
        :disabled="isLoading"
        max-width="800"
        class="mx-auto"
      >
        <!-- Error template -->
        <template v-if="error">
          <v-card-title>
            Error
          </v-card-title>

          <v-card-text>
            <div>
              An error occurred. <br />
              Please try again later or email
              <a href="mailto:Support@GlobalCoachGroup.com">
                Support@GlobalCoachGroup.com
              </a>for assistance.
            </div>
          </v-card-text>
        </template>

        <!-- Completed template -->
        <template v-else-if="completed">
          <v-card-title>
            Reset Password
          </v-card-title>

          <v-card-text>
            <div>
              The new password successfully saved.
            </div>
            <v-btn
              text
              class="mt-2 px-0"
              style="text-transform: none;"
              color="primary"
              @click="$router.push({ name: 'login' })"
            >
              Go back to login page
            </v-btn>
          </v-card-text>
        </template>

        <!-- Function template -->
        <template v-else>
          <v-card-title>
            Reset Password
          </v-card-title>
          <v-card-text>
            <v-form
              ref="passwordForm"
              v-model="validation"
            >
              <v-text-field
                v-model="password.new"
                label="New password"
                color="teal"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[...rules.rule1]"
                :type="show1 ? 'text' : 'password'"
                hint="At least 8 characters"
                counter
                @click:append="show1 = !show1"
                @keyup.enter="submit"
              />

              <v-text-field
                v-model="password.confirm"
                label="Confirm password"
                color="teal"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[...rules.rule2]"
                :type="show2 ? 'text' : 'password'"
                hint="At least 8 characters"
                counter
                @click:append="show2 = !show2"
                @keyup.enter="submit"
              />
            </v-form>
          </v-card-text>

          <v-card-actions
            class="d-flex justify-end"
          >
            <v-btn
              color="#003865"
              dark
              @click="submit"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import accountApi from '@/api/account/account';
import Header from '@/views/components/Header.vue';

export default {
  name: 'ResetPassword',

  components: {
    Header,
  },

  data: () => ({
    isLoading: true,
    error: false,
    completed: false,
    token: '',
    validation: false,
    password: {
      new: '',
      confirm: '',
    },
    show1: false,
    show2: false,
  }),

  computed: {
    rules() {
      // Init object
      const results = {};

      // name = rule name
      // key = data connection
      // rules = validator names in ruleHandler
      const rules = [
        {
          name: '1',
          key: 'new',
          rules: ['required', 'minimum', 'regEx'],
        },
        {
          name: '2',
          key: 'confirm',
          rules: ['required', 'matched'],
        },
      ];

      // `results = {rule${name}: [true, 'False text', true...], ...}`
      rules.forEach((rule) => {
        const res = this.ruleHandler(rule);
        results[res.name] = res.result;
      });

      return results;
    },
  },

  created() {
    this.token = this.$route.params.token;
    this.checkValidate();
  },

  methods: {
    async checkValidate() {
      try {
        this.isLoading = true;
        await accountApi.validateToken({
          token: this.token,
        });
      } catch (err) {
        console.log(err);
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },

    ruleHandler(rule) {
      // Get rule = { name, key, rules }
      // Validators
      const required = (key) => !!this.password[key] || `${key.charAt(0).toUpperCase() + key.substring(1)} password required.`;
      const minimum = (key) => (this.password[key]).length >= 8 || 'Password is at least 8 characters.';
      const matched = (key) => this.password.new === this.password[key] || 'Password does not match.';
      const regEx = (key) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!";#$%&'()*+,./:<=>?@[^_`{|}\-\]~])[A-Za-z\d!";#$%&'()*+,./:<=>?@[^_`{|}\-\]~]{8,}$/;
        return regex.test(this.password[key]) || 'Password must include one upper character[A-Z], one integer[0-9], and one special character.';
      };

      // Return object init
      const result = {
        name: `rule${rule.name}`,
        result: [],
      };

      // Get rule results
      (rule.rules).forEach((item) => {
        switch (item) {
          case 'required':
            result.result.push(required(rule.key));
            break;
          case 'minimum':
            result.result.push(minimum(rule.key));
            break;
          case 'matched':
            result.result.push(matched(rule.key));
            break;
          case 'regEx':
            result.result.push(regEx(rule.key));
            break;
          default:
            break;
        }
      });

      return result;
    },

    async submit() {
      if (this.$refs.passwordForm.validate()) {
        try {
          this.isLoading = true;
          await accountApi.resetPassword({
            token: this.token,
            password: this.password.new,
          });

          this.password.new = '';
          this.password.confirm = '';
          this.$refs.passwordForm.resetValidation();
          this.completed = true;
        } catch (err) {
          console.log('error', err);
          this.$toast.error('Error occurred. Please retry this later.');
        } finally {
          this.isLoading = false;
        }
      } else {
        this.$toast.error('Please check the fields.');
      }
    },
  },
};
</script>
